<template>
    <v-row class="row--xl footer-info">
        <v-col v-for="(item, index) in items" :key="index" cols="12" md="6">
            <u-txt-default class="txt--sm white--text mb-2 mb-md-4">
                {{ item.title }}
            </u-txt-default>
            <ul class="footer-info__list">
                <li v-for="(item, index) in item.items" :key="index">
                    <u-txt-default class="txt--sm grey--text text--lighten-3">
                        {{ item.title }} <span class="grey--text text--lighten-2">{{ item.text }}</span>
                    </u-txt-default>
                </li>
            </ul>
        </v-col>
    </v-row>
</template>

<script>
import UInlineGroup from "@/components/publish/styles/groups/u-inline-group.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";

export default {
    props: {},
    components: {
        UInlineGroup,
        UTxtDefault,
    },
    data() {
        return {
            items: [
                {
                    title: "답십리점",
                    items: [
                        { title: "패션봉제지원센터", text: "02-2212-5586" },
                        { title: "공용재단실", text: "02-2212-5581" },
                        { title: "이메일", text: "dongori@ddm.go.kr" },
                        { title: "[02596]", text: "동대문구 답십리로 38길 19. 창업지원센터 A동 1층" },
                    ],
                },
                {
                    title: "신설동점",
                    items: [
                        { title: "패션봉제복합지원센터", text: "02-6235-2201" },
                        { title: "공용재단실", text: "02-6235-2202" },
                        { title: "특종장비실", text: "02-6235-2203~4" },
                        { title: "이메일", text: "dongori@ddm.go.kr" },
                        { title: "[02579]", text: "동대문구 한빛로 62" },
                    ],
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.footer-info {
    &__list {
        > li {
            &:not(:first-child) {
                margin-top: 4px;
                @media (min-width: 768px) {
                    margin-top: 8px;
                }
            }
        }
    }
}
</style>
